import { FC, useState } from "react";
import { Button } from "../../../design-system";
import {
    AnalysisType,
    Project,
    ProjectAnalysis,
} from "../../../types/ProjectTypes";
import { getAnalysisOutputContentUrl } from "../../../common/api/ProjectClient";
import { getRelativeTime } from "../../date/DateOp";
import { useChatbotFlag } from "../../demo/chatbotFlag";
import { DrawerAssistant } from "../../assistant/demo/DrawerAssistant";
import { projectHasAskScript } from "../../assistant/demo/askScript";
import { ReactComponent as ThinkerIcon } from "../../../assets/icons/svg/thinker-gradient.svg";
import { AttachmentsDropdown } from "./AttachmentsDropdown";
import projectStyles from "../ProjectView.module.less";
import styles from "./FlexibleOutput.module.less";

interface FlexibleOutputProps {
    project: Project;
    analysis: ProjectAnalysis;
}

export const FlexibleOutput: FC<FlexibleOutputProps> = ({ project, analysis }) => {
    const [chatbotEnabled] = useChatbotFlag();
    const [assistantOpen, setAssistantOpen] = useState(false);
    const showAskButton = chatbotEnabled && projectHasAskScript(project.name);

    const titleText =
        analysis.type === AnalysisType.ROI
            ? "ROI ANALYSIS"
            : `NEGOTIATION PLAYBOOK V${analysis.version}`;

    const generatedDate =
        analysis.completedDate ?? analysis.submittedDate ?? analysis.recordCreationDate;

    return (
        <div className={`${projectStyles.tabContent} ${styles.container}`}>
            <div className={styles.header}>
                {showAskButton ? (
                    <Button
                        type="primary"
                        className={styles.askButton}
                        onClick={() => setAssistantOpen(true)}
                    >
                        <ThinkerIcon className={styles.askButtonIcon} />
                        <span className={styles.askButtonText}>
                            Hello Demo Customer, any questions about the report?
                        </span>
                    </Button>
                ) : (
                    <span className={styles.title}>
                        {titleText}
                        <span className={styles.generated}>
                            {" · generated "}
                            {getRelativeTime(generatedDate)}
                        </span>
                    </span>
                )}
                <AttachmentsDropdown project={project} analysis={analysis} />
            </div>
            <iframe
                src={getAnalysisOutputContentUrl(project.id, analysis.version)}
                className={styles.iframe}
                title="Report Content"
            />
            {showAskButton && (
                <DrawerAssistant
                    open={assistantOpen}
                    onClose={() => setAssistantOpen(false)}
                    projectName={project.name}
                />
            )}
        </div>
    );
};
